//to add roles or any condition to the navigation for main title go to src\@core\layouts\layout-vertical\components\vertical-nav-menu\components\vertical-nav-menu-group\VerticalNavMenuGroup.vue
//to add roles or any condition to the navigation for children title go to src\@core\layouts\layout-vertical\components\vertical-nav-menu\components\vertical-nav-menu-link\VerticalNavMenuLink.vue
/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
import reception from "./reception-department";
// import clinic from "./clinic-department";
import operations from "./operations-department";
import dashboard from "./main-dashboard";
import surgery from "./surgery-department";
import lab from "./lab-department";
import radiology from "./radiology-department";
import warehouse from "./warehouse-department";
import employee from "./employee-department";
import emergency from "./emergancy-department";
import pharmacy from "./pharmacy-department";
import ivf from "./ivf-department";
import hospital from "./hospital.departemnt";
import seniorHouseOffice from "./seniorHouseOffice-department";
import accounting from "./accounting-department";
import bloodBank from "./bloodBank-department";
// Array of sections
export default [
  ...dashboard,
  ...reception,
  ...seniorHouseOffice,
  // ...clinic,
  ...bloodBank,
  ...hospital,
  ...surgery,
  ...accounting,
  ...ivf,
  ...emergency,
  ...pharmacy,
  ...lab,
  ...radiology,
  ...employee,
  ...warehouse,
  ...operations,
];
